module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("用户名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "signInActions"
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('button', {
    staticClass: "active",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signUp.apply(null, arguments)
      }
    }
  }, [_vm._v("注 册")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bee51ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignUpForm.vue
// module id = 195
// module chunks = 1